import defaultTo from 'lodash/fp/defaultTo';
import flow from 'lodash/fp/flow';
import has from 'lodash/fp/has';
import head from 'lodash/fp/head';
import split from 'lodash/fp/split';

import '@formatjs/intl-relativetimeformat/polyfill.js';
import '@formatjs/intl-relativetimeformat/locale-data/cs';
import '@formatjs/intl-relativetimeformat/locale-data/da';
import '@formatjs/intl-relativetimeformat/locale-data/de';
import '@formatjs/intl-relativetimeformat/locale-data/en';
import '@formatjs/intl-relativetimeformat/locale-data/es';
import '@formatjs/intl-relativetimeformat/locale-data/et';
import '@formatjs/intl-relativetimeformat/locale-data/fr';
import '@formatjs/intl-relativetimeformat/locale-data/it';
import '@formatjs/intl-relativetimeformat/locale-data/lt';
import '@formatjs/intl-relativetimeformat/locale-data/lv';
import '@formatjs/intl-relativetimeformat/locale-data/nl';
import '@formatjs/intl-relativetimeformat/locale-data/pl';
import '@formatjs/intl-relativetimeformat/locale-data/pt';
import '@formatjs/intl-relativetimeformat/locale-data/ro';
import '@formatjs/intl-relativetimeformat/locale-data/sk';
import '@formatjs/intl-relativetimeformat/locale-data/sv';

import '@formatjs/intl-relativetimeformat/locale-data/hr';
import '@formatjs/intl-relativetimeformat/locale-data/nb';
import '@formatjs/intl-relativetimeformat/locale-data/hu';
import '@formatjs/intl-relativetimeformat/locale-data/sl';
import '@formatjs/intl-relativetimeformat/locale-data/fi';
import '@formatjs/intl-relativetimeformat/locale-data/el';
import '@formatjs/intl-relativetimeformat/locale-data/bg';
import '@formatjs/intl-relativetimeformat/locale-data/ko';

const DEFAULT_LOCALE = 'en-GB';

interface LocaleMap {
    [key: string]: string;
}

const supportedLocaleMap: LocaleMap = {
    'bg-BG': 'bg-BG',
    'cs-CZ': 'cs-CZ',
    'da-DK': 'da-DK',
    'el-GR': 'el-GR',
    'es-ES': 'es-ES',
    'et-EE': 'et-EE',
    'fi-FI': 'fi-FI',
    'fr-FR': 'fr-FR',
    'hr-HR': 'hr-HR',
    'hu-HU': 'hu-HU',
    'it-IT': 'it-IT',
    'lt-LT': 'lt-LT',
    'lv-LV': 'lv-LV',
    'nb-NO': 'nb-NO',
    'nl-NL': 'nl-NL',
    'pl-PL': 'pl-PL',
    'pt-PT': 'pt-PT',
    'ro-RO': 'ro-RO',
    'sk-SK': 'sk-SK',
    'sl-SI': 'sl-SI',
    'sv-SE': 'sv-SE',
    'de-DE': 'de-DE',
    'pt-BR': 'pt-BR',
    'ko-KR': 'ko-KR',

    bg: 'bg-BG',
    cs: 'cs-CZ',
    da: 'da-DK',
    el: 'el-GR',
    es: 'es-ES',
    et: 'et-EE',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hr: 'hr-HR',
    hu: 'hu-HU',
    it: 'it-IT',
    lt: 'lt-LT',
    lv: 'lv-LV',
    nb: 'nb-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    pt: 'pt-PT',
    ro: 'ro-RO',
    sk: 'sk-SK',
    sl: 'sl-SI',
    sv: 'sv-SE',
    de: 'de-DE',
    ko: 'ko-KR',
};

const extractLanguage = flow(defaultTo(DEFAULT_LOCALE), split('-'), head);

const DEFAULT_LANG = extractLanguage(DEFAULT_LOCALE);

const getSupportedLocale = (preferredLocale: string): string =>
    has(preferredLocale, supportedLocaleMap) ? supportedLocaleMap[preferredLocale] : DEFAULT_LOCALE;

export { DEFAULT_LANG, DEFAULT_LOCALE, extractLanguage, getSupportedLocale, supportedLocaleMap };
